import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CartDirectivesModule } from '../../directives';

import { ButtonsModule } from '@shared/core/components/buttons';
import { BadgesModule } from '@shared/core/components/badges';

import { CartButtonComponent } from './cart-button.shared.component';

@NgModule({
    declarations: [
        CartButtonComponent
    ],
    imports: [
        CommonModule,
        ButtonsModule,
        BadgesModule,
        CartDirectivesModule,
    ],
    exports: [
        CartButtonComponent
    ],
    providers: [],
})
export class CartButtonModule { }
